function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("title", null, "34101470-E2E4-4A55-AE0D-13DCEB8CFCE9");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Main",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "input-and-search-/-1.5-select-destination-",
  transform: "translate(-108.000000, -880.000000)",
  fill: "#CCCCCC",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-64",
  transform: "translate(108.000000, 876.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(0.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.5,19.1666667 L10.8333333,19.1666667 L10.8333333,17.5 L12.5,17.5 L12.5,19.1666667 M15.8333333,17.5 L14.1666667,17.5 L14.1666667,19.1666667 L15.8333333,19.1666667 L15.8333333,17.5 M12.5,14.1666667 L10.8333333,14.1666667 L10.8333333,15.8333333 L12.5,15.8333333 L12.5,14.1666667 M5.83333333,17.5 L4.16666667,17.5 L4.16666667,19.1666667 L5.83333333,19.1666667 L5.83333333,17.5 M5.83333333,14.1666667 L4.16666667,14.1666667 L4.16666667,15.8333333 L5.83333333,15.8333333 L5.83333333,14.1666667 M15.8333333,14.1666667 L14.1666667,14.1666667 L14.1666667,15.8333333 L15.8333333,15.8333333 L15.8333333,14.1666667 M12.5,10.8333333 L10.8333333,10.8333333 L10.8333333,12.5 L12.5,12.5 L12.5,10.8333333 M15.8333333,10.8333333 L14.1666667,10.8333333 L14.1666667,12.5 L15.8333333,12.5 L15.8333333,10.8333333 M17.5,7.5 C18.4204746,7.5 19.1666667,8.24619208 19.1666667,9.16666667 L19.1666667,19.1666667 L17.5,19.1666667 L17.5,9.16666667 L9.16666667,9.16666667 L9.16666667,19.1666667 L7.5,19.1666667 L7.5,12.5 L2.5,12.5 L2.5,19.1666667 L0.833333333,19.1666667 L0.833333333,12.5 C0.833333333,11.5795254 1.57952542,10.8333333 2.5,10.8333333 L7.5,10.8333333 L7.5,9.16666667 C7.5,8.24619208 8.24619208,7.5 9.16666667,7.5 L9.16666667,5.83333333 C9.16666667,4.91285875 9.91285875,4.16666667 10.8333333,4.16666667 L12.5,4.16666667 L12.5,0.833333333 L14.1666667,0.833333333 L14.1666667,4.16666667 L15.8333333,4.16666667 C16.7538079,4.16666667 17.5,4.91285875 17.5,5.83333333 L17.5,7.5 M15.8333333,7.5 L15.8333333,5.83333333 L10.8333333,5.83333333 L10.8333333,7.5 L15.8333333,7.5 Z",
  id: "Icon-Shape"
})))));
const SvgCity = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCity, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/city.8c9bffda.svg";
export { ForwardRef as ReactComponent };